<template>
  <div>
    <button :class="['btn','btn-primary',{disabled:disabled}, 'theme-'+ theme]" v-on="$listeners">
      <slot></slot>
    </button>
  </div>
</template>

<script>
export default {
  name: 'cms-button',
  props:{
    disabled:{
      default: false
    }, 
    theme:{
      default:"standart"
    }
  }
}
</script>

<style scoped lang="scss">
.btn {
    &.btn-primary {
        width:60%;
        margin:1rem;
        border-radius: 5px;
        letter-spacing: 0.5px;
        border: none;   
        color: $white-five-color;    

      &.theme-standart{
        background-color: $bluish-two-color;
      }
      &.theme-dark{
        background-color: $dark-blue-color;
      }
    }
}
</style>
